import React from 'react';
import PropTypes from 'prop-types';
import { useDividerGradient } from '../gradient-utils';

export function Steps({
  className,
  depth = 50,
  position = 50,
  fadeOpacity,
  fadeDirection,
  softness,
  style
}) {
  const { defs, fill, mask } = useDividerGradient({ fadeOpacity, fadeDirection, softness });

  const scale = depth / 50;
  const y = val => 200 - (120 - val) * scale;

  // Focal point (lowest step) position: 0=left, 50=center, 100=right
  const focalX = (position / 100) * 1200;

  // Step X positions
  const stepX = [0, 200, 400, 600, 800, 1000, 1200];

  // Heights vary based on distance from focal point (closer = lower/taller)
  const getHeight = x => {
    const dist = Math.abs(x - focalX);
    const normalizedDist = Math.min(dist / 600, 1);
    return 20 + normalizedDist * 60;
  };

  // Build step points (horizontal then vertical for each step)
  const points = ['0,200', `0,${y(getHeight(0))}`];
  for (let i = 1; i < stepX.length; i++) {
    const currX = stepX[i] || 0;
    const prevX = stepX[i - 1] || 0;
    points.push(`${currX},${y(getHeight(prevX))}`);
    points.push(`${currX},${y(getHeight(currX))}`);
  }
  points.push('1200,200');

  return (
    <svg
      className={ className }
      style={ style }
      viewBox='0 0 1200 200'
      preserveAspectRatio='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      { defs }
      <polygon points={ points.join(' ') } fill={ fill } mask={ mask } />
    </svg>
  );
}

Steps.propTypes = {
  className: PropTypes.string,
  depth: PropTypes.number,
  position: PropTypes.number,
  fadeOpacity: PropTypes.number,
  fadeDirection: PropTypes.oneOf(['down', 'up', 'left', 'right']),
  softness: PropTypes.number
};
